<template>
  <section class="client-cabinet-plain-section" data-testid="client-page-prolongs" aria-labelledby="client-page-prolongs-title">
    <div class="client-cabinet-section-heading">
      <div>
        <h2 id="client-page-prolongs-title" data-testid="client-page-prolongs-title">
          {{ $t("client_page.cabinet.prolongs.title", { count: prolongs.length }) }}
        </h2>
        <p>{{ $t("client_page.cabinet.prolongs.changes", { count: prolongs.length }) }}</p>
      </div>
    </div>
      <ul class="client-cabinet-list">
        <li
          v-for="(prolong, index) in prolongs"
          :key="index"
          class="client-cabinet-row"
          data-field="booking.prolongs[].last_date booking.prolongs[].prolong_days booking.prolongs[].prolong_hours booking.prolongs[].prolong_weeks booking.prolongs[].prolong_months booking.prolongs[].new_price booking.prolongs[].old_price booking.prolongs[].created_at"
        >
          <span>
            <span class="d-block">{{ period(prolong) }}</span>
            <span class="text-body-2 client-cabinet-muted">{{ $t("client_page.cabinet.prolongs.until", { date: wallDate(prolong.last_date) }) }} · {{ formatDate(prolong.created_at) }}</span>
          </span>
          <span class="text-right">
            <strong class="d-block">{{ m(prolong.new_price) }}</strong>
            <span v-if="prolong.old_price && prolong.old_price !== prolong.new_price" class="text-body-2">
              {{ $t("client_page.cabinet.prolongs.price_was", { amount: m(prolong.old_price) }) }}
            </span>
          </span>
        </li>
      </ul>
  </section>
</template>

<script>
// FT-200 STEP-05 (REQ-08): свёрнутые «Продления (N)» — срок продления, до какой даты, цена периода.
// last_date — настенное время под меткой UTC (как в карточке сотрудника): показывается без сдвига пояса.
import { formatCabinetDate, money } from "@/utils/clientCabinetView";

export default {
  name: "ProlongsBlock",
  props: {
    prolongs: { type: Array, default: () => [] },
    company: { type: Object, default: null },
  },
  methods: {
    m(value) {
      return money(value, this.company && this.company.currency_symbol);
    },
    period(prolong) {
      if (prolong.prolong_months > 0) return this.$t("client_page.cabinet.duration_months", { count: prolong.prolong_months });
      if (prolong.prolong_weeks > 0) return this.$t("client_page.cabinet.duration_weeks", { count: prolong.prolong_weeks });
      if (prolong.prolong_hours > 0 && !(prolong.prolong_days > 0)) return this.$t("client_page.cabinet.duration_hours", { count: prolong.prolong_hours });
      return this.$t("client_page.cabinet.duration_days", { count: prolong.prolong_days || 0 });
    },
    wallDate(date) {
      return formatCabinetDate(date, (this.$i18n && this.$i18n.locale) || "ru");
    },
    formatDate(date) {
      return formatCabinetDate(date, (this.$i18n && this.$i18n.locale) || "ru", "D MMMM");
    },
  },
};
</script>
